import React from "react";

const Proposal = () => {
  const proposals = [
    {
      title: "Uploaded Proposal",
      num: 10,
      color: "bg-[#015AA8]",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.1666 16.9833H29.35C25.4 16.9833 22.1833 13.7667 22.1833 9.81668V5.00001C22.1833 4.08334 21.4333 3.33334 20.5166 3.33334H13.45C8.31663 3.33334 4.16663 6.66668 4.16663 12.6167V27.3833C4.16663 33.3333 8.31663 36.6667 13.45 36.6667H26.55C31.6833 36.6667 35.8333 33.3333 35.8333 27.3833V18.65C35.8333 17.7333 35.0833 16.9833 34.1666 16.9833ZM19.2166 22.55C18.9666 22.8 18.65 22.9167 18.3333 22.9167C18.0166 22.9167 17.7 22.8 17.45 22.55L16.25 21.35V28.3333C16.25 29.0167 15.6833 29.5833 15 29.5833C14.3166 29.5833 13.75 29.0167 13.75 28.3333V21.35L12.55 22.55C12.0666 23.0333 11.2666 23.0333 10.7833 22.55C10.3 22.0667 10.3 21.2667 10.7833 20.7833L14.1166 17.45C14.2333 17.35 14.35 17.2667 14.4833 17.2C14.5166 17.1833 14.5666 17.1667 14.6 17.15C14.7 17.1167 14.8 17.1 14.9166 17.0833C14.9666 17.0833 15 17.0833 15.05 17.0833C15.1833 17.0833 15.3166 17.1167 15.45 17.1667C15.4666 17.1667 15.4666 17.1667 15.4833 17.1667C15.6166 17.2167 15.75 17.3167 15.85 17.4167C15.8666 17.4333 15.8833 17.4333 15.8833 17.45L19.2166 20.7833C19.7 21.2667 19.7 22.0667 19.2166 22.55Z"
            fill="#FFFBFF"
          />
          <path
            d="M29.05 14.6833C30.6333 14.7 32.8333 14.7 34.7167 14.7C35.6667 14.7 36.1667 13.5833 35.5 12.9167C33.1 10.5 28.8 6.15001 26.3333 3.68334C25.65 3.00001 24.4667 3.46668 24.4667 4.41668V10.2333C24.4667 12.6667 26.5333 14.6833 29.05 14.6833Z"
            fill="#FFFBFF"
          />
        </svg>
      ),
    },
    {
      title: "Reviewed Proposal",
      num: 10,
      color: "bg-[#E0AF00]",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6667 36.3167C14.35 37 15.5333 36.5333 15.5333 35.5833V29.7667C15.5333 27.3333 13.4667 25.3167 10.95 25.3167C9.36666 25.3 7.16666 25.3 5.28333 25.3C4.33333 25.3 3.83333 26.4167 4.49999 27.0833C6.89999 29.5 11.2 33.85 13.6667 36.3167Z"
            fill="#FFFBFF"
          />
          <path
            d="M5.83337 23.0167H10.65C14.6 23.0167 17.8167 26.2333 17.8167 30.1833V35C17.8167 35.9167 18.5667 36.6667 19.4834 36.6667H26.55C31.6834 36.6667 35.8334 33.3333 35.8334 27.3833V12.6167C35.8334 6.66665 31.6834 3.33332 26.55 3.33332H13.45C8.31671 3.33332 4.16671 6.66665 4.16671 12.6167V21.35C4.16671 22.2667 4.91671 23.0167 5.83337 23.0167ZM18.3334 13.75L25.3167 13.75L24.1167 12.55C23.6334 12.0667 23.6334 11.2667 24.1167 10.7833C24.3667 10.5333 24.6834 10.4167 25 10.4167C25.3167 10.4167 25.6334 10.5333 25.8834 10.7833L29.2167 14.1167C29.3334 14.2333 29.4 14.35 29.4667 14.4833C29.4834 14.5167 29.5 14.5667 29.5167 14.6C29.55 14.7 29.5667 14.8 29.5834 14.9C29.5834 14.95 29.5834 14.9833 29.5834 15.0333C29.5834 15.1667 29.55 15.3 29.5 15.4333C29.5 15.45 29.5 15.45 29.4834 15.4667C29.4334 15.6 29.3334 15.7333 29.2334 15.8333C29.2167 15.85 29.2167 15.8667 29.2 15.8667L25.8667 19.2C25.3834 19.6833 24.5834 19.6833 24.1 19.2C23.6167 18.7167 23.6167 17.9167 24.1 17.4333L25.3 16.2333L18.3334 16.2333C17.65 16.2333 17.0834 15.6667 17.0834 14.9833C17.0834 14.3 17.65 13.75 18.3334 13.75Z"
            fill="#FFFBFF"
          />
        </svg>
      ),
    },
    {
      title: "Accepted Proposal",
      num: 10,
      color: "bg-[#6EBC14]",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.9167 3.33334H16.0833C14.35 3.33334 12.9333 4.73334 12.9333 6.46668V8.03334C12.9333 9.76668 14.3333 11.1667 16.0667 11.1667H23.9167C25.65 11.1667 27.05 9.76668 27.05 8.03334V6.46668C27.0667 4.73334 25.65 3.33334 23.9167 3.33334Z"
            fill="#FFFBFF"
          />
          <path
            d="M28.7334 8.03333C28.7334 10.6833 26.5667 12.85 23.9167 12.85H16.0834C13.4334 12.85 11.2667 10.6833 11.2667 8.03333C11.2667 7.1 10.2667 6.51666 9.4334 6.95C7.0834 8.2 5.4834 10.6833 5.4834 13.5333V29.2167C5.4834 33.3167 8.8334 36.6667 12.9334 36.6667H27.0667C31.1667 36.6667 34.5167 33.3167 34.5167 29.2167V13.5333C34.5167 10.6833 32.9167 8.2 30.5667 6.95C29.7334 6.51666 28.7334 7.1 28.7334 8.03333ZM25.5667 21.2167L18.9001 27.8833C18.6501 28.1333 18.3334 28.25 18.0167 28.25C17.7001 28.25 17.3834 28.1333 17.1334 27.8833L14.6334 25.3833C14.1501 24.9 14.1501 24.1 14.6334 23.6167C15.1167 23.1333 15.9167 23.1333 16.4001 23.6167L18.0167 25.2333L23.8001 19.45C24.2834 18.9667 25.0834 18.9667 25.5667 19.45C26.0501 19.9333 26.0501 20.7333 25.5667 21.2167Z"
            fill="#FFFBFF"
          />
        </svg>
      ),
    },
    {
      title: "Declined Proposal",
      num: 10,
      color: "bg-[#D73737]",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.5305 14.1228C35.8658 14.7285 35.3871 15.4167 34.6948 15.4167H4.33325C3.78097 15.4167 3.33325 14.969 3.33325 14.4167V10.7C3.33325 6.63334 6.63325 3.33334 10.6999 3.33334H14.5666C17.2833 3.33334 18.1333 4.21668 19.2166 5.66668L21.5499 8.76668C22.0666 9.45001 22.1333 9.53334 23.0999 9.53334H27.7499C31.0962 9.53334 34.0144 11.3842 35.5305 14.1228Z"
            fill="#FFFBFF"
          />
          <path
            d="M36.6366 18.9125C36.6348 18.3615 36.1876 17.9159 35.6366 17.9159L4.33324 17.9164C3.78096 17.9164 3.33325 18.3641 3.33325 18.9164V27.7498C3.33325 32.6664 7.33325 36.6664 12.2499 36.6664H27.7499C32.6666 36.6664 36.6666 32.6664 36.6666 27.7498L36.6366 18.9125ZM23.8999 30.4664C23.6499 30.6998 23.3333 30.8331 23.0166 30.8331C22.6999 30.8331 22.3666 30.6998 22.1333 30.4664L20.0666 28.3998L17.9333 30.5331C17.6999 30.7664 17.3666 30.8998 17.0499 30.8998C16.7333 30.8998 16.4166 30.7664 16.1666 30.5331C15.6833 30.0498 15.6833 29.2498 16.1666 28.7664L18.2999 26.6331L16.2333 24.5664C15.7499 24.0831 15.7499 23.2831 16.2333 22.7998C16.7333 22.3164 17.5166 22.3164 17.9999 22.7998L20.0666 24.8664L22.0666 22.8664C22.5499 22.3831 23.3333 22.3831 23.8333 22.8664C24.3166 23.3664 24.3166 24.1498 23.8333 24.6331L21.8333 26.6331L23.8999 28.6998C24.3833 29.1831 24.3833 29.9831 23.8999 30.4664Z"
            fill="#FFFBFF"
          />
        </svg>
      ),
    },
  ];

  return (
    <>
      <div className="flex gap-5 h-48 my-5">
        {proposals.map((data) => {
          return (
            <div className={`w-full rounded-lg p-5 flex flex-col gap-3 ${data.color}`}>
              {data.icon}
              <p className="text-white font-normal">{data.title}</p>
              <h1 className="text-4xl text-white font-bold">{data.num}</h1>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Proposal;
